<template>
    <DCard
        padding
    >
        <Form
            :tld-mapping="tldMapping"
            :errors="errors"
            :products="products"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/TldMappings/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    products: {
        type: Array,
        default: () => { return [] }
    },
    tldMapping: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.patch(route('products.tld-product-mappings.update', { tld_product_mapping: props.tldMapping.id }))
}
</script>
